import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig } from "primeng/api";
import { finalize } from "rxjs/internal/operators/finalize";
import { RequestBuilder } from "src/app/classes/request-builder";
import { ICommessa } from "src/app/interfaces/ICommessa";
import { IGruppo } from "src/app/interfaces/IGruppo";
import { CommessaService } from "src/app/services/commessa.service";
import { AlertUtil } from "src/app/utils/alert-util";

@Component({
  selector: "app-commessa-list-modal",
  templateUrl: "./commessa-list-modal.component.html",
  styleUrls: ["./commessa-list-modal.component.css"],
})
export class CommessaListModalComponent implements OnInit {
  group: IGruppo;
  commesse: ICommessa[];

  constructor(
    private config: DynamicDialogConfig,
    private commessaService: CommessaService,
    private alertUtil: AlertUtil
  ) {
    this.group = this.config.data.gruppo;
  }

  ngOnInit() {
    this.loadCommesse(this.group.Id);
  }

  private loadCommesse(groupId: number) {
    //Loading.isLoading = true
    let reqBuilder = new RequestBuilder({
      Id: groupId,
    });
    this.commessaService
      .getCommessaByGruppo(reqBuilder)
      .pipe(
        finalize(() => {
          //Loading.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            this.commesse = response.data;
          } else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log("ERROR: " + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", {
              error: response.Message,
            });
          }
        },
        (error) => {
          let errorKey = "LBL_HTTP_ERROR_0";
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }
}
